import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import SeoHead from "@/components/feature/SeoHead";
import Newsletter from "@/components/feature/Newsletter";
import { faqs } from "@/mocks/content";
import CoverHero from "./components/CoverHero";
import LatestFeed from "./components/LatestFeed";
import DeepDive from "./components/DeepDive";
import ArchiveSection from "./components/ArchiveSection";
import BrandSection from "./components/BrandSection";
import FaqSection from "./components/FaqSection";

const origin = "https://zuori-chigua.example";

const webJson = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "昨日吃瓜",
    url: origin,
    inLanguage: "zh-CN",
    description:
      "深入昨日吃瓜细节分析，挖掘瓜田隐藏线索与蛛丝马迹，关联人物和时间线梳理同步放出。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <SeoHead
        title="昨日吃瓜｜娱乐热点细节复盘与瓜田时间线分析"
        description="昨日吃瓜专注昨日吃瓜细节分析，整理瓜田隐藏线索与蛛丝马迹，同步放出关联人物与时间线梳理，围绕未解之谜展开深挖，满足你的好奇与探究欲。"
        keywords="昨日吃瓜,昨日吃瓜细节分析,昨日瓜田隐藏线索,昨日吃瓜未解之谜,昨日瓜田关联人物"
        path="/"
        ogType="website"
        ogImage="https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%20with%20watermelon%20red%20and%20melon%20green%20on%20cream%20paper%2C%20flat%20ink%2C%20no%20text&width=1200&height=630&seq=og-home&orientation=landscape"
        jsonLd={webJson}
      />
      <Header />
      <main>
        <CoverHero />
        <LatestFeed />
        <DeepDive />
        <ArchiveSection />
        <BrandSection />
        <FaqSection />

        {/* subscribe */}
        <section id="subscribe" className="scroll-mt-24 border-y border-background-300/60 bg-accent-100">
          <div className="mx-auto max-w-7xl px-4 py-12 text-center md:px-6 md:py-16">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-500 text-background-50">
              <i className="ri-mail-send-line text-2xl" aria-hidden="true" />
            </span>
            <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              每一期复盘上线时，第一时间送到你手里
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              订阅「昨日瓜报」，热门话题的完整时间线与细节分析，不再错过。
            </p>
            <div className="mt-7">
              <Newsletter />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}